import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";

import { myGlobals, myUtilities } from "../../Utils";
import OnlinePaymentMethods from "../onlinePaymentMethods";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import PaypalPayment from "../PaypalPayment";
import CCProcessor from "../CCProcessor";
import OnlinePaymentDIPage from "../OnlinePaymentDIPage";

import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import { callReduxForTxnLimitALert } from '../../App';

import {
  PaymentSelectionCardView,
  SepaPaymentForm,
  SepaPaymentDIPage,
  PaymentElements,
  CreditCardPaymentDIPage,
  PayButton,
  CreditCardPaymentContainer,
} from "./";
import {AlertTxnLimit} from '../Common';
import { CANADA_COUNTRY_CODE, USA_COUNTRY_CODE } from "../../Utils/utils";
import CanadianRoutingNumberFields from "./CanadianRoutingNumberFields";
import DOMPurify from "dompurify";
import GuestPayDirectDebitDI from "./GuestPayDirectDebitDI";
import Back from '../../Images/back.svg';

class PaymentContainer extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      selected: "SELECTION",
    };
    this.invData = null;
    this.payData = null;
    this.changeSelectedState.bind(this);
  }

  changeSelectedState = (newValue) => {
    this.setState({
      selected: newValue
    });
  };

  setSelectedMethod = async (
    val,
    paymentData,
    convenienceFee,
    surchargeAmount
  ) => {
    if (paymentData != undefined)
      await paymentData.setTotalConvenienceFeeAndSurcharge(
        convenienceFee,
        surchargeAmount
      );
    this.setState({
      selected: val,
    });
  };
  checkContentSelected = () => {
    return this.state.selected;
  };
  checkRef = (data, invoiceData) => {
    if (data.state.formRef) {
      let flagAllow = 1;
      if (this.formRef.current["bankAccNo"].value == "") {
        flagAllow = 0;
      }
      if (this.formRef.current["bankName"].value == "") {
        flagAllow = 0;
      }
      
      if (data.getCurrentCountryCode().toUpperCase() === "US") {
      if (
        this.formRef.current["routingNo"].value == "" ||
        this.formRef.current["routingNo"].value.length != 9
      ) {
        flagAllow = 0;
      } }
      
      if (this.formRef.current["accountName"].value == "") {
        flagAllow = 0;
      }

      // Mandate fields
      if (invoiceData.state.bankTransferConfigFields && invoiceData.state.bankTransferConfigFields.length > 0) {
        invoiceData.state.bankTransferConfigFields.forEach((field) => {
          if (field.isMandatory 
              && (field.fieldType.toLowerCase() === "input")) {
            if (this.formRef.current[field.eippFieldDisplayName].value == "") {
              flagAllow = 0;
            }
          } else if (field.isMandatory && (field.fieldType.toLowerCase() === "inputdropdown")) {
            // childNodes[0] is the span element
            // childNodes[0].innerText is the value of the span element
            if (this.formRef.current[field.eippFieldDisplayName].childNodes[0].innerText == "") {
              flagAllow = 0;
            }
          }
        });
      }

      if (flagAllow === 1) {
        data.setAllowSubmit(true);
      } else data.setFormRef(false);
    }
  };

  handleSubmit = (event, invData, payData) => {
    event.preventDefault();
    myGlobals.handleACHFormSubmit(invData, payData);
  };

  dynamicBankTransferConfigFieldsData = (invoiceData) => {
    let data =  invoiceData ? invoiceData.state : {};
    let bankTransferConfigFields = (data.bankTransferConfigFields !== undefined && 
      data.bankTransferConfigFields !== null && 
      data.bankTransferConfigFields !== "" ) ? data.bankTransferConfigFields : [];


     let achMandatoryFieldsList = [];

    bankTransferConfigFields.forEach((field) => {
      if (field.fieldType.toLowerCase() == "input") {
        achMandatoryFieldsList.push(
          <Row>
            <PaymentElements
              name={DOMPurify.sanitize(field.eippFieldDisplayName)}
              header={
                <div>
                  {myUtilities.accountSpecificLanguage(
                    field.eippFieldMlKey,
                    field.eippFieldDisplayName
                  )}
                  {field.isMandatory ? <span className="red-asterisk">*</span> : null}
                </div>
              }
              key={field.eippFieldDisplayName}
              isMandateField
              isRequiredField={DOMPurify.sanitize(field.isMandatory)}
              customValidationRegex={DOMPurify.sanitize(field.validationRegex)}
              customValidationMessage={DOMPurify.sanitize(field.validationMessage)}
              customValidationMessageMLKey={DOMPurify.sanitize(field.validationMessageMlKey)}
            />
          </Row>
        );
      } else if (field.fieldType.toLowerCase() == "inputdropdown") {
        achMandatoryFieldsList.push(
          <Row>
            <PaymentElements
              name={field.eippFieldDisplayName}
              header={
                <div>
                  {myUtilities.accountSpecificLanguage(
                    field.eippFieldMlKey,
                    field.eippFieldDisplayName
                  )}
                  {field.isMandatory ? <span className="red-asterisk">*</span> : null}
                </div>
              }
              key={field.eippFieldDisplayName}
              isEIPPDropdown={true}
              dropdownStoreName={field.eippDbColumn + ".BankFields"}
              isMandateField
            />
          </Row>
        );
      }
    });
    return (achMandatoryFieldsList)

  };

  returnContentBasedOnPaymentMethod = (data, invoiceData) => {
    if (this.state.selected.localeCompare("SELECTION") === 0) {
      return (
        <Row>
          <Col>
            <PaymentSelectionCardView
              setSelectedMethod={this.setSelectedMethod}
            />
          </Col>
        </Row>
      );
    } else if (this.state.selected.localeCompare("PROCESSING") === 0) {
      return <CCProcessor changeSelectedState={this.changeSelectedState} paymentData={data} invData={invoiceData} backButtonOnClick={this.backButtonOnClick} />;
    } else if (this.state.selected.localeCompare("TRUSTLY") === 0) {
      return <OnlinePaymentMethods paymentMethod="TRUSTLY" />;
    } else if (this.state.selected.localeCompare("GIROPAY") === 0) {
      return <OnlinePaymentMethods paymentMethod="GIROPAY" />;
    } else if (this.state.selected.localeCompare("IDEAL") === 0) {
      return <OnlinePaymentMethods paymentMethod="IDEAL" />;
    } else if (this.state.selected.localeCompare("BANCONTACT") === 0) {
      return <OnlinePaymentMethods paymentMethod="BANCONTACT" />;
    } else if (this.state.selected.localeCompare("PAYPAL") === 0) {
      return <PaypalPayment paymentMethod="PAYPAL" />;
    } else if (this.state.selected.localeCompare("ACH") === 0) {
      let isStripeProcessor = false;
      if(invoiceData.state.selectedInvoices){
       isStripeProcessor = invoiceData.state.selectedInvoices.some((invoice) => {
          return invoice.processorName && invoice.processorName.toLowerCase() === "stripe";
      })
      }if(invoiceData.state.isPMTDIEnabled){
          return  <GuestPayDirectDebitDI  />
      }else if (invoiceData.state.isSepa) {
        return <SepaPaymentForm />;
      } else if (invoiceData.state.achCountryDropdownValues &&  invoiceData.state.achCountryDropdownValues.length === 1 
        && invoiceData.state.achCountryDropdownValues[0] === "CA" && ((invoiceData.state.processorName && invoiceData.state.processorName.toLowerCase() === "stripe") || isStripeProcessor)) {
          callReduxForTxnLimitALert(
            "Alert.stripe.not.supported.canada.bank.account",
            "Currently, our system does not support guest payments using Canadian bank accounts for this invoice/group of invoices. Please use a different payment instrument",
            {}
          )   
        return  <p/>
      } else
        return (
          <React.Fragment>
            <form
              // custom CSS class only for bank transfer config fields
              className={
                invoiceData.state.bankTransferConfigFields &&
                invoiceData.state.bankTransferConfigFields.length > 0
                  ? "ach-form"
                  : ""
              }
              onSubmit={(event) => {
                this.handleSubmit(event, invoiceData, data);
              }}
              ref={this.formRef}
            >
              <Row>
              {((invoiceData.state.processorName && invoiceData.state.processorName.toLowerCase() === "stripe") || isStripeProcessor) && invoiceData.state.achCountryDropdownValues && invoiceData.state.achCountryDropdownValues.includes("CA") && invoiceData.state.achCountryDropdownValues.length > 1 && (
              <div className="warning-text" style={{color:'red',paddingLeft:'10px',margin:'4px'}}>
                <span className="red-asterisk">*</span>
                {myUtilities.accountSpecificLanguage(
                  "Alert.stripe.not.supported.canada.bank.account",
                  "Currently, our system does not support guest payments using Canadian bank accounts for this invoice/group of invoices.   Please use a different payment instrument",
                )} 
                </div>
              )}
             </Row>
              <Row>
                <PaymentElements
                  name={"bankAccNo"}
                  header={
                    <div>
                      {myUtilities.accountSpecificLanguage(
                        "ACH.Form.Header.bankaccount",
                        "Bank Account Number"
                      )}
                      <span className="red-asterisk">*</span>
                    </div>
                  }
                  isHalf
                  accountType
                  header2={
                    <div>
                      {myUtilities.accountSpecificLanguage(
                        "ACHForm.AccountType",
                        "Account Type"
                      )}
                      <span className="red-asterisk">*</span>:
                    </div>
                  }
                  name2={"accountType"}
                  key={"bankAccNo" + invoiceData.state.resetNum}
                />
              </Row>
              <Row>
                <PaymentElements
                  name={"bankName"}
                  header={
                    <div>
                      {myUtilities.accountSpecificLanguage(
                        "ACH.Form.Header.bankname",
                        "Bank Name"
                      )}
                      <span className="red-asterisk">*</span>
                    </div>
                  }
                  isHalf
                  header2={
                    <div>
                      {myUtilities.accountSpecificLanguage(
                        "ACH.Form.Header.countrycode",
                        "Country Code"
                      )}
                      <span className="red-asterisk">*</span>
                    </div>
                  }
                  name2={"countryCode"}
                  key={"bankName" + invoiceData.state.resetNum}
                  selectedCard={this.state.selected}
                  isStripeProcessor={isStripeProcessor}
                />
              </Row>
              <Row>
                {data.getCurrentCountryCode() &&
                  data.getCurrentCountryCode().toUpperCase() ===
                    USA_COUNTRY_CODE && (
                    <PaymentElements
                      name={"routingNo"}
                      header={
                        <div>
                          {myUtilities.accountSpecificLanguage(
                            "ACH.Form.Header.routingnumber",
                            "Routing Number"
                          )}
                          <span className="red-asterisk">
                            *
                          </span>
                        </div>
                      }
                      isNumber
                      key={
                        "routingNo" + invoiceData.state.resetNum
                      }
                    />
                  )}
                {(data.getCurrentCountryCode() &&
                  data.getCurrentCountryCode() ===
                    CANADA_COUNTRY_CODE) && (!(invoiceData.state.processorName && invoiceData.state.processorName.toLowerCase() === "stripe" ) || !isStripeProcessor) && (
                    <CanadianRoutingNumberFields
                      invoiceData={invoiceData.state}
                      paymentData={data}
                    />
                  )}

              </Row>
              <Row>
                <PaymentElements
                  name={"accountName"}
                  header={
                    <div>
                      {myUtilities.accountSpecificLanguage(
                        "ACH.Form.Header.accountname",
                        "Account Holder's Name"
                      )}
                      <span className="red-asterisk">*</span>
                    </div>
                  }
                  key={"accountName" + invoiceData.state.resetNum}
                />
              </Row>
              {/* {invoiceData.state.achMandatoryFieldsList} */}
              {this.dynamicBankTransferConfigFieldsData(invoiceData)}
              <Row
                className={
                  invoiceData.state.bankTransferConfigFields &&
                  invoiceData.state.bankTransferConfigFields.length >
                    0
                    ? "row-pay-button-with-bank-config"
                    : "row-pay-button"
                }>
                <PayButton />
              </Row>
            </form>
            {this.checkRef(data, invoiceData)}
          </React.Fragment>
        );
    } else if (this.state.selected.localeCompare("SEPADI") === 0)
      return <SepaPaymentDIPage />;
    else if (this.state.selected.localeCompare("ONLINEPAYMENTDI") === 0) {
      return <OnlinePaymentDIPage />;
    } else if (this.state.selected.localeCompare("IFRAMEDI") === 0) {
      return <OnlinePaymentDIPage loadInIframe />;
    } else if (this.state.selected.localeCompare("CC") === 0) {
      return <CreditCardPaymentDIPage />;
    } else if (this.state.selected.localeCompare("DC") === 0) {
        return <CreditCardPaymentDIPage />;
     } else if (this.state.selected.localeCompare("loading") === 0) {
      return (
        <div>
          {myUtilities.accountSpecificLanguage("Loading", "Loading" )}!
        </div>
      );
    } else if (this.state.selected.localeCompare("failure") === 0) {
      return  (
    	        <div>
    	          {myGlobals.isDCFlow
    	            ? myUtilities.accountSpecificLanguage(
    	                "DebitCard.Error.NotEligible",
    	                "Not eligible for DC payment"
    	              )
    	            : myUtilities.accountSpecificLanguage(
    	                "CreditCard.Error.NotEligible",
    	                "Not eligible for CC payment"
    	              )}
    	        </div>
    	      );
    }
  };
  determineCSSForCreditCard = () => {
    if (this.state.selected.localeCompare("ACH") === 0) {
      return "ACH";
    } else return "CC";
  };
  backButtonOnClick = (paymentData, invData) => {
	if(this.state.selected && this.state.selected.localeCompare("PROCESSING") === 0)
	        return;
    this.setSelectedMethod("SELECTION");
    myGlobals.paymentMethod = "";
    let discVal;
    let totalAmt;
    if (myGlobals.isDiscountEnabled && !isNaN(parseFloat(invData.state.lastAppliedTotal)) && !isNaN(parseFloat(invData.state.lastAppliedDiscVal))) {
      discVal = invData.state.lastAppliedDiscVal;
      totalAmt = parseFloat(invData.state.lastAppliedTotal).toFixed(2);
    } else {
      discVal = invData.getTotalDiscountAmount(invData.state.selectedInvoices);
      totalAmt = invData.getTotalInvoiceAmount(invData.state.selectedInvoices);
      if (myGlobals.isDiscountEnabled) {
        totalAmt = parseFloat(totalAmt) - parseFloat(discVal);
      }
      totalAmt = parseFloat(totalAmt).toFixed(2);
    }
    invData.setState({
      total: totalAmt,
      totalDiscVal: discVal,
      partialPayProceeded: false,
    });
    paymentData.setTotalConvenienceFeeAndSurcharge(null, null);
    paymentData.setTotalLateFee(null);
    paymentData.setACHMandateFields(null);
  };
  showBackButton = (paymentData, invData) => {
    this.invData = invData;
    this.payData = paymentData;
    if (this.state.selected.localeCompare("SELECTION") !== 0 && !myGlobals.isDirectDebitLoaded) 
      return (
        <img
          onClick={() => {
            this.backButtonOnClick(paymentData, invData);
          }}
          src={Back}
          className="back-button"
        />
      );
  };
  resetContainer = () => {
    this.setState({
      selected: "SELECTION",
    });
    this.invData.populateData(myGlobals.topBuildResponse);
    this.payData.setState({
      totalConvienceFee: null,
      totalSurchargeAmount: null,
    });
  };
  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Subscribe to={[InvoiceDataContainer]}>
            {(invData) => (
              <Container
                id="pay-through-email-payment-container-id"
                className="payment-container"
              >
	           <AlertTxnLimit
	              paymentData={data}
	              invData={invData}
	              backButtonOnClick={this.backButtonOnClick}
	            />
                <Row>
                  <Col className="payment-details-container">
                    {this.showBackButton(data, invData)}
                    <CreditCardPaymentContainer backButtonOnClick={this.backButtonOnClick}  />
                    {myUtilities.accountSpecificLanguage(
                      "Payment.Container.Header.Payment.Details",
                      "PAYMENT DETAILS"
                    )}
                  </Col>
                </Row>
                {this.returnContentBasedOnPaymentMethod(data, invData)}
              </Container>
            )}
          </Subscribe>
        )}
      </Subscribe>
    );
  }
  componentDidMount = () => {
    myGlobals.selectedStateMethodPaymentContainer = this.setSelectedMethod;
    myGlobals.checkPaymentContentSelected = this.checkContentSelected;
    window.currentComponent = this;
  };
  
}

export default PaymentContainer;
